 const MonthConvert_year = (string) =>{
  const monthMap = {
    '01': 'janvier',
    '02': 'février',
    '03': 'mars',
    '04': 'avril',
    '05': 'mai',
    '06': 'juin',
    '07': 'juillet',
    '08': 'août',
    '09': 'septembre',
    '10': 'octobre',
    '11': 'novembre',
    '12': 'décembre'
  };
    var [year,month, day] = string.split('-');
    string =  day+' . '+monthMap[month]+' . '+year
    return string
}
const MonthConvert = (string) =>{
  const monthMap = {
    '01': 'janvier',
    '02': 'février',
    '03': 'mars',
    '04': 'avril',
    '05': 'mai',
    '06': 'juin',
    '07': 'juillet',
    '08': 'août',
    '09': 'septembre',
    '10': 'octobre',
    '11': 'novembre',
    '12': 'décembre'
  };
    var [month, day] = string.split('-');
    string =  day+'. '+monthMap[month]
    return string
}
export { MonthConvert,MonthConvert_year}